{
  "infoTypes": [
    {
      "title": "New Features",
      "filename": "newFeatures.json"
    },
    {
      "title": "Changes",
      "filename": "Changes.json"
    }
  ],
  "versions": [
    {
      "major": 11,
      "minor": 16,
      "dirname": "1116",
      "title": "Service Pack 16",
      "isLTS": true,
      "lifecycle": {
        "techPrev": "2019-06-15",
        "ga": "2019-08-15",
        "eol": "2024-06-15"
      }
    },
    {
      "major": 11,
      "minor": 17,
      "dirname": "1117",
      "title": "Service Pack 17",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2019-09-15",
        "ga": "2019-11-15",
        "eol": "2020-12-15"
      }
    },
    {
      "major": 11,
      "minor": 18,
      "dirname": "1118",
      "title": "Service Pack 18",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2019-12-15",
        "ga": "2020-02-15",
        "eol": "2021-03-15"
      }
    },
    {
      "major": 11,
      "minor": 19,
      "dirname": "1119",
      "title": "Feature Release 11.19",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2020-03-15",
        "ga": "2020-05-15",
        "eol": "2021-06-15"
      }
    },
    {
      "major": 11,
      "minor": 20,
      "dirname": "1120",
      "title": "Feature Release 11.20",
      "isLTS": true,
      "lifecycle": {
        "techPrev": "2020-06-15",
        "ga": "2020-08-15",
        "eol": "2025-06-15"
      }
    },
    {
      "major": 11,
      "minor": 21,
      "dirname": "1121",
      "title": "Feature Release 11.21",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2020-09-15",
        "ga": "2020-11-15",
        "eol": "2021-12-15"
      }
    },
    {
      "major": 11,
      "minor": 22,
      "dirname": "1122",
      "title": "Feature Release 11.22",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2020-12-15",
        "ga": "2021-02-15",
        "eol": "2022-03-15"
      }
    },
    {
      "major": 11,
      "minor": 23,
      "dirname": "1123",
      "title": "Feature Release 11.23",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2021-03-15",
        "ga": "2021-05-15",
        "eol": "2022-06-15"
      }
    },
    {
      "major": 11,
      "minor": 24,
      "dirname": "1124",
      "title": "Feature Release 11.24",
      "isLTS": true,
      "lifecycle": {
        "techPrev": "2021-06-15",
        "ga": "2021-08-15",
        "eol": "2024-06-15"
      }
    },
    {
      "major": 11,
      "minor": 25,
      "dirname": "1125",
      "title": "Feature Release 11.25",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2021-09-15",
        "ga": "2021-11-15",
        "eol": "2022-09-15"
      }
    },
    {
      "major": 11,
      "minor": 26,
      "dirname": "1126",
      "title": "Feature Release 11.26",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2021-12-15",
        "ga": "2022-02-15",
        "eol": "2022-12-15"
      }
    },
    {
      "major": 11,
      "minor": 28,
      "dirname": "2022e",
      "title": "Commvault Platform Release 2022E (11.28)",
      "isLTS": true,
      "lifecycle": {
        "techPrev": "2022-06-15",
        "ga": "2022-08-15",
        "eol": "2025-06-15"
      }
    },
    {
      "major": 11,
      "minor": 30,
      "dirname": "2023",
      "title": "Commvault Platform Release 2023 (11.30)",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2022-12-15",
        "ga": "2023-02-15",
        "eol": "2023-12-15"
      }
    },
    {
      "major": 11,
      "minor": 32,
      "dirname": "2023e",
      "title": "Commvault Platform Release 2023E (11.32)",
      "isLTS": true,
      "lifecycle": {
        "techPrev": "2023-06-15",
        "ga": "2023-08-15",
        "eol": "2026-06-15"
      }
    },
    {
      "major": 11,
      "minor": 34,
      "dirname": "2024",
      "title": "Commvault Platform Release 2024 (11.34)",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2023-12-15",
        "ga": "2024-02-15",
        "eol": "2024-12-15"
      }
    },
    {
      "major": 11,
      "minor": 36,
      "dirname": "2024e",
      "title": "Commvault Platform Release 2024E (11.36)",
      "isLTS": true,
      "lifecycle": {
        "techPrev": "2024-06-15",
        "ga": "2024-08-15",
        "eol": "2027-06-15"
      }
    },
    {
      "major": 11,
      "minor": 38,
      "dirname": "1138",
      "title": "Innovation Release 11.38",
      "isLTS": false,
      "lifecycle": {
        "techPrev": "2024-12-15",
        "ga": "2025-02-15",
        "eol": "2025-12-15"
      }
    },
    {
      "major": 11,
      "minor": 40,
      "dirname": "1140",
      "title": "Commvault Long-Term Support Release 11.40",
      "isLTS": true,
      "lifecycle": {
        "ga": "2025-06-15",
        "eol": "2027-12-15"
      }
    },
    {
      "major": 11,
      "minor": 42,
      "dirname": "1142",
      "title": "Commvault Innovation Release 11.42",
      "isLTS": false,
      "lifecycle": {
        "ga": "2025-07-14",
        "eol": "2026-07-15"
      }
    },
    {
      "major": 11,
      "minor": 44,
      "dirname": "1144",
      "title": "Commvault Long-Term Support Release 11.44",
      "isLTS": true,
      "lifecycle": {
        "ga": "2026-07-15",
        "eol": "2028-12-15"
      }
    },
    {
      "major": 11,
      "minor": 46,
      "dirname": "1146",
      "title": "Commvault Innovation Release 11.46",
      "isLTS": false,
      "lifecycle": {
        "ga": "2026-07-15",
        "eol": ""
      }
    }
  ]
}
